<template>
  <header class="header">
    <nav>
      <router-link to="/home">Projekty</router-link>
      <router-link to="/about">O mnie</router-link>
    </nav>
  </header>
</template>

<style lang="scss">
.header {
  border-bottom: 4px solid #d3d3d3;
  font-size: 1.5rem;

  nav {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;

    @media (min-width: 40em) {
      flex-direction: row;
      font-size: 2rem;
    }

    padding: 30px;

    a {
      text-transform: uppercase;

      padding: 0.5rem 1rem;

      border-image-source: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="UTF-8" ?><svg version="1.1" width="5" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2 1 h1 v1 h-1 z M1 2 h1 v1 h-1 z M3 2 h1 v1 h-1 z M2 3 h1 v1 h-1 z" fill="rgb(33,37,41)" /></svg>');
      border-image-repeat: round;
      border-image-slice: 2;
      border-image-width: 2;
      border-image-outset: 2;
      border-style: solid;
      border-width: 4px;
      box-shadow: 4px 8px #000, 0 0 #000, 8px 4px #000, 0 0 #000;

      color: #2c3e50;
      cursor: pointer;

      display: inline-block;
      transition: all 0.3s ease-out;

      &.router-link-exact-active {
        background-color: #e7e7e7;
      }

      &:hover {
        transform: translateY(-3px);
      }

      &:active {
        transform: translateY(-1px);
      }
    }
  }
}
</style>
